<template>
	<div class="invoice">
		<div class="nav">
			<van-icon name="arrow-left" color="#fff" size="1.1rem" @click="back" />
			<span>填写合同信息</span>
			<div></div>
		</div>
		<div class="block">
			<van-form validate-first @submit="onFailed">
				<van-field v-model="title" label="承租方名称" name="title" placeholder="请输入公司名称" />
				<van-field v-model="address" label="地　　址" name="address" placeholder="请输入公司地址" />
				<van-field v-model="tel" label="联 系 电 话" type="number" name="tel" placeholder="请输入注册固定电话" />
				<van-field v-model="name" label="授权代理人" name="name" placeholder="请输入授权人姓名" />
				<div class="bottom" style="margin: 16px;">
					<van-button style="height: 2rem; line-height: 2rem;" round block type="info" color="#F1452F" native-type="submit">
						提交
					</van-button>
				</div>
			</van-form>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				title: '',
				address: '',
				tel: '',
				name: '',
			}
		},
		created() {

		},
		methods: {
			onFailed(errorInfo) {
				this.form == errorInfo;
				errorInfo.token = localStorage.getItem('Authorization')
				errorInfo.order_number = this.$route.query.order_number
				this.$axios.post(baseUrl + '/mobile/order/contractAdd', errorInfo).then((res) => {
					this.$toast("提交信息成功");
					this.$router.push({
						path: "/mycontract",
					})
				}).catch((err) => {
					console.log(err);
				});
			},
		}
	}
</script>

<style>
	.invoice .block {
		width: 94%;
		margin: auto;
		background-color: #fff;
		margin-top: 3.125rem;
		border-radius: 0.65rem;
		padding: 0.875rem 0;
	}

	.invoice .van-cell__title {
		text-align: left;
		width: 4.7rem;
	}

	.invoice .van-cell {
		line-height: 2.25rem;
	}

	.invoice .van-radio--horizontal {
		margin-top: 0.5rem;
	}

	.invoice .van-cell__value {
		margin-left: 0.9375rem;
	}
</style>



// WEBPACK FOOTER //
// src/components/contract/contract.vue